import { useState } from "react";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import Navbar from "scenes/widgets/navbar";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [feedback, setFeedback] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = searchParams.get("token");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setFeedback({ severity: "error", text: "Passwoerter stimmen nicht ueberein." });
      return;
    }
    setIsSubmitting(true);
    setFeedback(null);
    try {
      const response = await fetch(`${BASE_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Passwort konnte nicht gesetzt werden.");
      }
      setFeedback({
        severity: "success",
        text: data.message || "Passwort erfolgreich aktualisiert.",
      });
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      setFeedback({
        severity: "error",
        text: error.message || "Passwort konnte nicht gesetzt werden.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box>
      <Navbar />
      <Box maxWidth="560px" mx="auto" mt="2rem" p="2rem">
        <Typography variant="h4" mb="1rem">
          Passwort zurücksetzen
        </Typography>
        {!token && (
          <Alert severity="error" sx={{ mb: "1rem" }}>
            Reset-Link ist ungültig.
          </Alert>
        )}
        {feedback && (
          <Alert severity={feedback.severity} sx={{ mb: "1rem" }}>
            {feedback.text}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Neues Passwort"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{ mb: "1rem" }}
          />
          <TextField
            fullWidth
            label="Passwort wiederholen"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: "1rem", mr: "0.5rem" }}
            disabled={isSubmitting || !token}
          >
            Passwort speichern
          </Button>
          <Button component={RouterLink} to="/einloggen" sx={{ mt: "1rem" }}>
            Zum Login
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default ResetPasswordPage;

